import { Link } from 'react-router-dom';
import styles from './Button.module.css';

/**
 * @param {{
 *   children: React.ReactNode,
 *   variant?: 'primary' | 'secondary' | 'ghost',
 *   size?: 'md' | 'lg',
 *   to?: string,
 *   href?: string,
 *   onClick?: () => void,
 *   type?: 'button' | 'submit',
 *   disabled?: boolean,
 * }} props
 */
export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  to,
  href,
  onClick,
  type = 'button',
  disabled = false,
  className: extraClassName = '',
  ...rest
}) {
  const className = `${styles.btn} ${styles[variant]} ${styles[size]} ${extraClassName}`;

  if (to) {
    return (
      <Link to={to} className={className} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={className} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button type={type} className={className} onClick={onClick} disabled={disabled} {...rest}>
      {children}
    </button>
  );
}
